import { Box, Typography, CircularProgress } from '@mui/material';
import { useAuthStore } from '../../stores/useAuthStore';
import { useLoadingStore, selectIsMainLoading } from '../../stores/useLoadingStore';

export default function ProfilesBtn({
    total = 0,
    data = []
}) {

    const perfisDisponiveis = useAuthStore(state => state.perfisDisponiveis);
    const perfisSelecionados = useAuthStore(state => state.perfisSelecionados);

    const isMainLoading = useLoadingStore(selectIsMainLoading);

    if(isMainLoading){
        return (
            <CircularProgress size={20} />
        )
    }

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
            }}
        >
            {perfisSelecionados.map(perfilId => {
                const dadosDoPerfil = data.filter(l => l.unidade_opera === perfilId);
                const nomePerfil = perfisDisponiveis.find(p => p.id === perfilId)?.nome || `Perfil ${perfilId}`;

                if (dadosDoPerfil.length === 0) return null;

                const percent = total > 0
                    ? Math.round((dadosDoPerfil.length / total) * 100)
                    : 0;

                return (
                    <Typography key={perfilId} variant="body2">
                        {nomePerfil}: <strong>{dadosDoPerfil.length} {perfisSelecionados.length > 1 ? `(${percent}%)` : ''}</strong>
                    </Typography>
                );
            })}
        </Box>
    );

}